/**
 * pages/contact.js
 *
 * Enqueued from page-templates/page-contact.php with:
 *   whytheme_enqueue_script('pages/contact');
 *
 * Handles: switching between the general-contact and reports CF7 forms
 * (sections/contact/contact-form). Every [data-cyclo-form-panel] whose key
 * doesn't match the checked radio is hidden — that covers both the intro
 * text and the form itself. No-ops when only one form is configured.
 */

function initFormSwitch() {
    document.querySelectorAll('[data-cyclo-form-switch]').forEach((root) => {
        const inputs = root.querySelectorAll('[data-cyclo-form-switch-input]');
        const panels = root.querySelectorAll('[data-cyclo-form-panel]');

        const show = (key) => {
            panels.forEach((panel) => {
                panel.hidden = panel.dataset.cycloFormPanel !== key;
            });
        };

        inputs.forEach((input) => {
            input.addEventListener('change', () => {
                if (input.checked) show(input.value);
            });
        });

        // Browsers can restore a different radio on back/forward navigation.
        const checked = root.querySelector('[data-cyclo-form-switch-input]:checked');
        if (checked) show(checked.value);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormSwitch);
} else {
    initFormSwitch();
}
